import { Box, Chip, Typography } from "@mui/material";
import { Item } from "../../utils/types/generals";
import { useState } from "react";

const styles = {

  showMore: {
    fontSize: '13px',
    cursor: 'pointer',
    color: '#158bc8',
    marginTop: '10px',
    textAlign: 'right',
  },
  chipsContainer: {
    marginTop: '5px',
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap',
  },
  chipUnFocus: ({ color }: { color?: string }) => ({
    background: color ?? '#31c462',
    color: 'white',

    '&.MuiChip-clickable:hover': {
      backgroundColor: color ?? '#31c462',
    },
  }),
}

const ChipsList = (props: { value: Item[]; handleDelete: (option: any) => void; colorsByChips?: Record<string, string>; showAllInModal?: boolean; onShowModal?: () => void; label?: string }) => {
  const [showMore, setShowMore] = useState(false)
  const lengthData = props.value?.length > 5

  const onShowMore = () => {
    if (props.showAllInModal && props.onShowModal) {
      props.onShowModal();
    } else {
      setShowMore(!showMore)
    }
  }

  return (
    <>
      <Box sx={styles.chipsContainer}>
        {props.showAllInModal
          ? (() => {
              const seen = new Set();
              return props.value.filter(item => {
                const key = String(item.value);
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
              }).map((option, index) => (
                <Chip sx={styles.chipUnFocus({ color: option?.color ?? props.colorsByChips?.[option.value] })} variant="outlined" key={option.value} label={option.label} clickable onDelete={() => props.handleDelete(option)} />
              ));
            })()
          : props.value?.slice(0, (!showMore && !!lengthData) ? 4 : undefined)?.map((option, index) => (
              <Chip sx={styles.chipUnFocus({ color: option?.color ?? props.colorsByChips?.[option.value] })} variant="outlined" key={option.value} label={option.label} clickable onDelete={() => props.handleDelete(option)} />
            ))
        }
      </Box>

      {props.value && (props.value.length > 5) && (
        <Box className="show showButon" sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography
            variant="body1"
            sx={styles.showMore}
            onClick={onShowMore}
          >
            {!showMore ? "Mostrar más" : "Mostrar menos"}
          </Typography>
        </Box>
      )}
    </>
  )
}

export { ChipsList }
